import { useTokenBalance } from './useTokenBalance';
import { getVlrTokenAddress } from '../claimer/utils';

export function useVlrTokenBalance() {
  const tokenAddress = getVlrTokenAddress();
  const { balance, isLoading, error, formatted } = useTokenBalance(tokenAddress);

  return {
    balance,
    formatted,
    isLoading,
    error,
  };
}
